import React, { Component, PropTypes } from 'react';
import ModalLabelSettings from '../../modals/ModalLabelSettings';
import ModalConfirmationSettings from '../../modals/ModalConfirmationSettings';
import Store from '../../../store/Store';
import { get } from 'lodash';

class PagesAddOns extends Component {
    render() {
        const components = get(this.props.routes, [this.props.routes.length - 1, 'components']);
        const { labels, itemToShow } = components;
        return (
            <div>
                {labels ? (
                    <ModalLabelSettings
                        store={Store}
                        location={this.props.location.pathname}
                        component={itemToShow}
                        route={this.props.route}
                        router={this.props.router}
                    />
                ) : (
                    <ModalConfirmationSettings
                        store={Store}
                        location={this.props.location.pathname}
                        router={this.props.router}
                        route={this.props.route}
                        component={itemToShow}
                    />
                )}
            </div>
        );
    }
}

PagesAddOns.propTypes = {
    children: PropTypes.element
};

export default PagesAddOns;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesAddOns.js